import { Badge, ThemeColor } from "@deligoo/ui"
import { ComponentProps } from "react"
import { useTranslation } from "react-i18next"

import { OrderPointState, OrderState } from "@/types"
import { getIconFor } from "@/utils"

type OrderStatusBadgeProps = {
  state: OrderState | OrderPointState
} & ComponentProps<typeof Badge>

export const OrderStatusBadge = ({ state, ...props }: OrderStatusBadgeProps) => {
  const { t } = useTranslation()

  return (
    <Badge
      color={getStateColor(state)}
      variation={getStateBadgeVariation(state)}
      iconProps={{
        name: getIconFor(state),
      }}
      {...props}
    >
      {t(`orders:${state}`)}
    </Badge>
  )
}

function getStateColor(state: OrderState | OrderPointState): ThemeColor {
  switch (state) {
    case "assigned":
    case "published":
      return "warning"
    case "started":
      return "info"
    case "in_progress":
      return "accent"
    case "finished":
      return "success"
    case "canceled":
    case "failed":
      return "alert"
    default:
      return "muted"
  }
}

function getStateBadgeVariation(state: OrderState | OrderPointState) {
  switch (state) {
    case "assigned":
    case "canceled":
    case "expired":
      return "accented"
    case "published":
    case "started":
    case "in_progress":
    case "finished":
    case "failed":
      return "solid"
    default:
      return "outlined"
  }
}
